import React from 'react';
import { Button, Icon, Confirm, Grid, Table, Dimmer, Loader, Message } from 'semantic-ui-react';
import ViewKey from './ViewKey';
import axios from 'axios';
import _ from 'lodash';
import Zello from './Zello'
import './Keys.css';

class Keys extends React.Component {
  componentDidMount() {
    axios.request({
      url: Zello.getApiUrl('/keys'),
      method: 'get',
      withCredentials: true
    }).then((response) => {
      if (response.data && response.data.keys !== undefined) {
        _.each(response.data.keys, (key) => {
          key.created = Zello.formatDate(key.createdTs);
        });
        this.setState({
          loaded: true,
          keys: response.data.keys
        })
      } else {
        throw new Error("invalid response")
      }
    }).catch((e) => {
      this.setState({
        loaded: true,
        message: 'Unable to load your current keys'
      });
      console.log(e);
    });
  }

  onAddKey = () => {
    axios.request({
      url: Zello.getApiUrl('/keys'),
      method: 'post',
      withCredentials: true
    }).then((response) => {
      if (response.data && response.data.key !== undefined) {
        let keys = this.state.keys;
        keys.push({
          id: response.data.key.number,
          number: keys.length + 1,
          key: response.data.key.public,
          sha: response.data.key.sha,
          created: Zello.formatDate(response.data.key.createdTs)
        });
        this.setState({
          keys: keys,
          viewKey: -1,
          newKey: {
            publicKey: response.data.key.public,
            privateKey: response.data.key.private,
            token: response.data.key.devToken,
            issuer: response.data.key.issuer,
            sha: response.data.key.sha
          }
        });
      } else {
        throw new Error("invalid response")
      }
    }).catch((e) => {
      this.setState({
        message: 'Unable to create a new key'
      });
      console.log(e);
    });
  };

  onConfirm = () => {
    const keyNumber = this.state.deleteKeyId;
    axios.request({
      url: Zello.getApiUrl('/keys/' + keyNumber),
      method: 'delete',
      withCredentials: true
    }).then((response) => {
      let keys = _.filter(this.state.keys, (key) => {
        return key.id !== keyNumber;
      });

      let i = 1;
      _.each(keys, (key) => {
        key.number = i;
        i++;
      });

      this.setState({
        shouldConfirm: false,
        keys: keys
      });
    }).catch((e) => {
      this.setState({
        shouldConfirm: false,
        message: 'Unable to delete key'
      });
      console.log(e);
    });
  };

  onConfirmCancel = () => {
    this.setState({
      shouldConfirm: false
    })
  };

  state = {
    keys: [],
    checked: [],
    viewKey: -1,
    newKey: null,
    shouldConfirm: false,
    loaded: false,
    message: ''
  };

  onView = (key) => {
    this.setState({
      viewKey: key
    });
  };

  onViewClose = () => {
    this.setState({
      newKey: null,
      viewKey: -1
    });
  };

  onDismiss = () => {
    this.setState({message: ''});
  };

  render() {
    let viewKey = null;
    if (this.state.viewKey >= 0) {
      viewKey = <ViewKey
        keyId={this.state.viewKey}
        publicKey={this.state.keys[this.state.viewKey - 1].key}
        open={true}
        issuer={this.state.keys[this.state.viewKey - 1].issuer}
      />
    } else if (this.state.newKey) {
      viewKey = <ViewKey
        keyId={this.state.viewKey}
        publicKey={this.state.newKey.publicKey}
        privateKey={this.state.newKey.privateKey}
        issuer={this.state.newKey.issuer}
        token={this.state.newKey.token}
        onClose={this.onViewClose}
        open={true}
      />
    }

    return (
      <div>
        <Confirm open={this.state.shouldConfirm} content={`Delete key ` + this.state.deleteKeySha + '?'} onCancel={this.onConfirmCancel} onConfirm={this.onConfirm}/>
        <Grid centered>
          <Grid.Column width={8}>
            {this.state.message && <Message
              onDismiss={this.onDismiss}
              content={this.state.message}
              error
            />}
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                Key ID
              </Table.HeaderCell>
              <Table.HeaderCell>
                Created
              </Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.state.keys.map(value => (
              <Table.Row key={value.id} className="key-row">
                <Table.Cell>
                  <Grid>
                    <Grid.Column textAlign="left" className="key-item" width={16} onClick={() => this.onView(value.number)}>
                      <span>{value.sha}</span>
                    </Grid.Column>
                  </Grid>
                </Table.Cell>
                <Table.Cell>
                  <Grid>
                    <Grid.Column textAlign="left" className="key-item" width={16} onClick={() => this.onView(value.number)}>
                      <span>{value.created}</span>
                    </Grid.Column>
                  </Grid>
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <Icon name='trash' className="key-delete" onClick={() => this.setState({
                    shouldConfirm: true,
                    viewKey: -1,
                    deleteKeySha: value.sha,
                    deleteKeyId: value.id
                  })}/>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
          <Table.Footer>
            {this.state.loaded &&
            <Table.Row>
              <Table.HeaderCell textAlign={this.state.keys.length === 0 ? "center" : "right"} colSpan={3}>
              {this.state.keys.length === 0 && <p>No keys associated with your account</p>}
              {this.state.keys.length < 10 && <Button aria-label="add" primary onClick={this.onAddKey}>Add Key</Button>}
              {viewKey}
              </Table.HeaderCell>
            </Table.Row>
            }
            {!this.state.loaded && <Table.Row>
              <Table.HeaderCell textAlign="center" colSpan={3}>
                <Dimmer active inverted>
                  <Loader inverted>Loading</Loader>
                </Dimmer>
              </Table.HeaderCell>
            </Table.Row>}
          </Table.Footer>
        </Table>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default Keys;



// WEBPACK FOOTER //
// ./src/Keys.js